module.exports = __webpack_public_path__ + "static/media/payment-agreement-stepper.7bccc305.svg";